import { Dropdown } from 'antd';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';
import { SortDishwasherBy } from '@common/enums';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { selectDishwasherSortBy, updateDishwashersSortBy } from '@redux/slices/dishwasherSlice';

import './dishwasher.scss';

export const SortDishwasher = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const dishwasherSortBy = useAppSelector(selectDishwasherSortBy);

    const sortByTitle = useMemo<string>(() => {
        switch (dishwasherSortBy) {
            case SortDishwasherBy.LowToHigh:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.PRICE_LOW_TO_HIGH')}`;
            case SortDishwasherBy.HighToLow:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.PRICE_HIGH_TO_LOW')}`;
            case SortDishwasherBy.NameAZ:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.NAME_A_Z')}`;
            case SortDishwasherBy.NameZA:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.NAME_Z_A')}`;
            case SortDishwasherBy.TrendingNow:
                return `${t('COMMON.SORT_BY')} : ${t('SCROLLABLE_AREA.COLOR.TRENDING_NOW')}`;
            default:
                return t('COMMON.SORT_BY');
        }
    }, [dishwasherSortBy]);

    function onSelectionChange(key: SortDishwasherBy | undefined) {
        // deselecting
        if (dishwasherSortBy === Number(key)) {
            dispatch(updateDishwashersSortBy(undefined));
            key = undefined;
        } else {
            dispatch(updateDishwashersSortBy(Number(key)));
        }
    }

    return (
        <Dropdown
            menu={{
                onClick: (e) => onSelectionChange(e.key as unknown as SortDishwasherBy),
                items: [
                    {
                        key: SortDishwasherBy.TrendingNow,
                        label: (
                            <div
                                className={classNames({
                                    selected: dishwasherSortBy === SortDishwasherBy.TrendingNow,
                                })}
                            >
                                {t('SCROLLABLE_AREA.COLOR.TRENDING_NOW')}
                            </div>
                        ),
                    },
                    {
                        key: SortDishwasherBy.LowToHigh,
                        label: (
                            <div
                                className={classNames({
                                    selected: dishwasherSortBy === SortDishwasherBy.LowToHigh,
                                })}
                            >
                                <span>{t('SCROLLABLE_AREA.COLOR.PRICE_LOW_TO_HIGH')}</span>
                            </div>
                        ),
                    },
                    {
                        key: SortDishwasherBy.HighToLow,
                        label: (
                            <div
                                className={classNames({
                                    selected: dishwasherSortBy === SortDishwasherBy.HighToLow,
                                })}
                            >
                                {t('SCROLLABLE_AREA.COLOR.PRICE_HIGH_TO_LOW')}
                            </div>
                        ),
                    },
                    {
                        key: SortDishwasherBy.NameAZ,
                        label: (
                            <div
                                className={classNames({
                                    selected: dishwasherSortBy === SortDishwasherBy.NameAZ,
                                })}
                            >
                                {t('SCROLLABLE_AREA.COLOR.NAME_A_Z')}
                            </div>
                        ),
                    },
                    {
                        key: SortDishwasherBy.NameZA,
                        label: (
                            <div
                                className={classNames({
                                    selected: dishwasherSortBy === SortDishwasherBy.NameZA,
                                })}
                            >
                                {t('SCROLLABLE_AREA.COLOR.NAME_Z_A')}
                            </div>
                        ),
                    },
                ],
            }}
        >
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                {sortByTitle} <DownOutlined />
            </a>
        </Dropdown>
    );
};
